import { Address, zeroAddress } from 'viem'
import { arbitrum, avalanche, base, bsc, mainnet, optimism, polygon } from 'viem/chains'
import { ChainId } from '../interfaces'

export const escrowHelper: Record<ChainId, Address> = {
  [optimism.id]: '0xC0e37937cD6B90d5Cc35E14EBE03Cb57B34430c8',
  [polygon.id]: '0xeAee97E3F5AF3814bD7947c5bccD210D1f4D0885',
  [avalanche.id]: '0xb475D0ecFF904613d2017bC7c47072343B8ec951',
  [mainnet.id]: zeroAddress,
  [arbitrum.id]: '0xd9B0E719F9b7ed52E541aEf5d2F75672A7b298fD',
  [base.id]: '0x723dBc296934EdEaa6da9Ba486CADF230b8c299d',
  [bsc.id]: '0xCca67eB8dd6dd3fA07B78Ae020E37e674c6277DF',
}

export const vaultViewers: Record<ChainId, Address> = {
  [arbitrum.id]: '0xEFF13712b5efaCF5213F9a76BC58D89f037D71D3',
  [avalanche.id]: '0x8FA99F5e2C5eE32334D658678DfC0C39c07d51dB',
  [mainnet.id]: '0x8FA99F5e2C5eE32334D658678DfC0C39c07d51dB',
  [optimism.id]: '0xfFa4a5935CD9Fa00DC6Bb28Bb6043Da6bE732d46',
  [polygon.id]: '0xF0f78B58343Dc242E895792e69Ef4D98FD647280',
  [base.id]: '0xAC683125cC47aC17b3E2A2C6555BF78Ba2b589C0',
  [bsc.id]: '0xE700D038e0bD9211B270C22BEf9Bd1647a1E4BF5',
}
